import React, { useEffect, useState } from 'react'
import '../css/staff.css';
import { Helmet } from 'react-helmet';
import { fetchStaff, slugify, resolveImageUrl } from '../utils/staffData';
import { STAFF_PHOTO_FALLBACKS, COMING_SOON_PHOTO } from '../images/staffPhotos';

function StaffPhoto({ member }) {
    const fallback = STAFF_PHOTO_FALLBACKS[slugify(member.name)] || COMING_SOON_PHOTO;
    const src = member.photo_url ? resolveImageUrl(member.photo_url) : fallback;
    const position = member.photo_position || 'center top';

    return (
        <div className="staffCard-photoFrame">
            <img
                src={src}
                alt={member.name}
                style={{ objectPosition: position }}
                onError={(e) => { e.currentTarget.src = COMING_SOON_PHOTO; }}
            />
        </div>
    );
}

export default function Staff() {
    const [staff, setStaff] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetchStaff()
            .then((data) => { if (!cancelled) setStaff(data); })
            .catch((err) => { if (!cancelled) setError(err.message); });
        return () => { cancelled = true; };
    }, []);

    return (
        <div className="staff-content">
            <Helmet>
                <title>In Motion Dance | Staff</title>
            </Helmet>
            <h1 className="staff-topText">Meet our team!</h1>

            {error && (
                <p className="staff-error">
                    We couldn't load the staff list ({error}). Please refresh, or contact the
                    studio if this keeps happening.
                </p>
            )}

            {!error && !staff && <p className="staff-loading">Loading our team…</p>}

            {staff && (
                <div className="staff-grid">
                    {staff.map((member, i) => (
                        <div className="staffCard" key={`${member.name}-${i}`}>
                            <StaffPhoto member={member} />
                            <div className="staffCard-body">
                                <h2>{member.name}</h2>
                                {member.role && <h3>{member.role}</h3>}
                                {member.bio.split('\n').filter(Boolean).map((para, i) => (
                                    <p key={i}>{para}</p>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
